import React from 'react';
import { containerClass, ContactCta, Disclosure, Eyebrow, leadClass, sectionTitleClass } from './ui';

const panelClass = 'flex flex-col gap-2 pb-5 text-[15px] leading-[1.55] text-gray-700 lg:max-w-[64ch] lg:pb-[22px]';
const labelClass = 'font-semibold text-gray-900';
const listClass = 'flex flex-col gap-1';

const BecomePilot: React.FC = () => {
  return (
    <section id="pilot-werden" className={`${containerClass} pb-10 pt-12 lg:grid lg:grid-cols-[5fr_7fr] lg:gap-16 lg:py-[72px]`}>
      <div>
        <Eyebrow>Ausbildung &amp; Mitfliegen</Eyebrow>
        <h2 className={`${sectionTitleClass} mb-3 lg:mb-4`}>Pilot werden</h2>
        <p className={`${leadClass} mb-6 lg:mb-7 lg:max-w-[40ch]`}>
          Entdecken Sie die Faszination des Fliegens und starten Sie Ihre Pilotenkarriere bei uns.
        </p>
        <ContactCta className="!hidden lg:!inline-flex">Jetzt Rundflug buchen oder Ausbildung starten!</ContactCta>
      </div>

      <div className="border-t-2 border-gray-900">
        <div className="border-b border-gray-200">
          <Disclosure id="weg-zum-flugschein" title="Der Weg zum Flugschein" size="lg" defaultOpen panelClassName={panelClass}>
            <p>
              Der Weg zum Flugschein führt bei uns über eine fundierte theoretische und praktische Ausbildung. Sie können jederzeit mit der Ausbildung beginnen und in Ihrem eigenen Tempo lernen.
            </p>
            <p className={labelClass}>Angebotene Lizenzen/Berechtigungen:</p>
            <ul className={listClass}>
              <li>Sportpilotenlizenz (SPL) für Ultraleichtflugzeuge</li>
              <li>Segelflugzeugführerschein (GPL)</li>
            </ul>
            <p>
              Sie können jederzeit mit der Ausbildung beginnen! Wir bieten regelmäßig Theorieunterricht an und die praktische Ausbildung ist ganzjährig möglich (wetterabhängig).
            </p>
          </Disclosure>
        </div>

        <div className="border-b border-gray-200">
          <Disclosure id="schnupperfluege" title="Schnupperflüge & Pilot für einen Tag" size="lg" panelClassName={panelClass}>
            <p>
              Sie sind sich noch nicht sicher, ob das Fliegen das Richtige für Sie ist? Kein Problem! Wir bieten verschiedene Möglichkeiten, um in die Welt der Luftfahrt hineinzuschnuppern.
            </p>
            <p className={labelClass}>Schnupperflüge:</p>
            <p>Fliegen Sie mit einem unserer erfahrenen Piloten mit und erleben Sie die Faszination des Fliegens hautnah.</p>
            <p className={labelClass}>Pilot für einen Tag:</p>
            <p>Steigen Sie ins Cockpit und übernehmen Sie das Steuer! Ihr Erlebnis beinhaltet:</p>
            <ul className={listClass}>
              <li>1 Stunde Theorie und technisches Briefing</li>
              <li>Einführung in das Flugzeug</li>
              <li>Etwa 1 Stunde Flugzeit, in der Sie selbst fliegen</li>
              <li>Nachbesprechung und Auswertung des Fluges</li>
            </ul>
            <p>Vorsicht: Dieses Erlebnis könnte Ihre Leidenschaft fürs Fliegen entfachen!</p>
          </Disclosure>
        </div>

        <div className="border-b border-gray-200">
          <Disclosure id="wichtige-informationen" title="Wichtige Informationen" size="lg" panelClassName={panelClass}>
            <p className={labelClass}>Flugbedingungen:</p>
            <ul className={listClass}>
              <li>Unsere Ultraleichtflugzeuge sind für zwei Personen zugelassen</li>
              <li>Alle Flüge erfolgen unter Sichtflugregeln (VFR)</li>
              <li>Wettervoraussetzungen: Kein Regen und kein starker oder böiger Wind</li>
              <li>Der Pilot vor Ort entscheidet über die Durchführung des Fluges</li>
            </ul>
            <p className={labelClass}>Betriebszeiten:</p>
            <p>Von 30 Minuten vor Sonnenaufgang bis 30 Minuten nach Sonnenuntergang</p>
            <p className={labelClass}>Bestellung von Rundflug-Gutscheinen:</p>
            <ol className={listClass}>
              <li>1. Füllen Sie das Online-Formular auf unserer Website aus</li>
              <li>2. Wählen Sie die gewünschte Dauer des Rundflugs</li>
              <li>3. Sie erhalten den Gutschein sowie die Rechnung per E-Mail</li>
              <li>4. Vereinbaren Sie anschließend einen Termin für Ihren Flug mit uns</li>
            </ol>
          </Disclosure>
        </div>
      </div>

      <ContactCta className="mt-6 lg:!hidden">Jetzt Rundflug buchen oder Ausbildung starten!</ContactCta>
    </section>
  );
};

export default BecomePilot;
